import { Box } from '@wix/design-system';
import { RuleListStatus } from '@wix/rules-panel-ui';
import _ from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { Pagination } from '../fixers/alt-image-fixer/drill-in/pagination-component/pagination';
const PAGE_SIZE = 50;
export const useSpecificRuleGroupPagination = _ref => {
  let {
    ruleGroups
  } = _ref;
  const sortGroupsByIssues = (a, b) => {
    const aFailed = a.ruleResults.filter(rule => rule.status === RuleListStatus.failed).length;
    const bFailed = b.ruleResults.filter(rule => rule.status === RuleListStatus.failed).length;
    return bFailed - aFailed;
  };
  const [currentPage, setCurrentPage] = useState(0);
  const ruleGroupsWithIssues = useMemo(() => ruleGroups.filter(group => group.ruleResults.some(rule => rule.status === RuleListStatus.failed)).sort(sortGroupsByIssues), [ruleGroups]);
  const ruleGroupsWithIssuesNumber = ruleGroupsWithIssues.length;
  const [isPaginationEnabled, setIsPaginationEnabled] = useState(ruleGroupsWithIssuesNumber === ruleGroups.length);
  const sortedByIssuesNumber = useMemo(() => ruleGroups.sort(sortGroupsByIssues), [ruleGroups]);
  const pages = useMemo(() => _.chunk(sortedByIssuesNumber, PAGE_SIZE), [sortedByIssuesNumber]);
  const pagesAmount = pages.length;
  const isPagination = useMemo(() => pagesAmount !== 1, [pagesAmount]);
  const getPaginationComponent = useCallback(() => {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      margin: "SP2 20px"
    }, /*#__PURE__*/React.createElement(Pagination, {
      currentPageNumber: currentPage,
      pagesAmount: pagesAmount,
      pageSize: PAGE_SIZE,
      totalItems: sortedByIssuesNumber.length,
      onClickBack: () => {
        setCurrentPage(currentPage - 1);
      },
      onClickNext: () => setCurrentPage(currentPage + 1)
    }));
  }, [currentPage, pagesAmount, sortedByIssuesNumber.length]);
  const basePaginationObject = useMemo(() => {
    return {
      getPaginationComponent,
      inNextButtonDisabled: currentPage === pagesAmount - 1,
      isPagination,
      isPaginationEnabled,
      isPreviousButtonDisabled: currentPage === 0,
      setIsPaginationEnabled
    };
  }, [currentPage, getPaginationComponent, isPagination, isPaginationEnabled, pagesAmount]);
  return useMemo(() => {
    if (ruleGroupsWithIssuesNumber === 0) {
      return {
        ...basePaginationObject,
        ruleGroupToShow: !isPaginationEnabled ? [] : pages[currentPage]
      };
    } else if (ruleGroupsWithIssuesNumber < PAGE_SIZE) {
      return {
        ...basePaginationObject,
        ruleGroupToShow: !isPaginationEnabled ? ruleGroupsWithIssues : pages[currentPage]
      };
    } else {
      return {
        ...basePaginationObject,
        isPaginationEnabled: true,
        ruleGroupToShow: pages[currentPage]
      };
    }
  }, [basePaginationObject, currentPage, isPaginationEnabled, pages, ruleGroupsWithIssues, ruleGroupsWithIssuesNumber]);
};
//# sourceMappingURL=use-specific-rule-group-pagination.js.map